module.exports = __webpack_public_path__ + "staticfr/media/Dt2.f39f7b56.jpg";